export const NTN_PAGE = [
  '109118231726792',
  '125865357450484', //NIVEA MEN
  '133498913379485', //NIVEA
  '111901618984646', //PRUDENTIAL
  '501378479972109', //HOP INN
  '10150142683120473', //	Veranda Resort
  '501378479972109', //HOP INN Hotel Thailand
  '107225204433671', //เพลิน
  '445913858762180', //O&B
  '157302513089660', //Never Been Better ผักปั่นบำเรอเซลส์ ไฟเบอร์สูง
  '148559413337', //TOA Paint
  '274108073649', //Ananda Development
  '134780360043928', //Bangkok Bank Careers
  '114683640172785', //FINNIX - ฟินนิกซ์
  '177518292310976', //Generali Thailand
  '184743472197249', //KASIKORN Career
  '1532996797026674', //Skoop Beach Café
  '200701213291845', //Bar B Q Plaza
  '1858940081055826', //TrueID
  '326180737483767', //Rabbit Finance
  '110218459027409', //wacoal thailand
  '330339053719456', //TERO Digital
  '347753078624', //ICC International PLC
  '126654220708334', //Banana
  '124043006254', //Rocky Resort - a Veranda Collection
  '111901618984646', //Prudential Thailand
  '829945033793366', //Loligo Resort Hua Hin
  '284395865686', //Let's Sea Hua Hin's Beach Restaurant
  '284823381567', //Let's Sea Hua Hin Al Fresco Resort
  '103235014977289', //UFUND
  '2037301563028410', //LAMY Thailand
  '102549712095297', //Next Capital - เน็คซ์ แคปปิตอล
  '168284766605902', //ทวียนต์ รถตรงจากโรงงาน
  '192311387589573', //Aurora Gold and Jewelry
  '396306053873110', //Thailandpostmart
  '165304889696', //Power Buy
  '495271297476302', //Summit Capital ซัมมิท แคปปิตอล
  '536678779695541', //Yamaha Society Thailand
  '440544769371763', //Nanake555
  '162369877131894', //เอราวอน (era-won)
  '208321456497173', //โปรเน็ตบ้านถูกใจ
  '103267601317473', //ล้างแอร์บ้าน กับ ฮิปโปแอร์ บริการล้างแอร์ที่คนบอกต่อมากที่สุด
  '367570166993820', //MJD.TH
  '141495096441743', //RunKan
  '204722943535880', //ICON CINECONIC
  '205538499712', //Samed Resorts
  '627661304102768', //Isuzu Trucks Thailand
  '272899549394796', //All-New Isuzu D-Max
  '194390934103303', //All-New Isuzu MU-X
  '125865357450484', //NIVEA MEN (TH)
  '133498913379485', //NIVEA (TH)
  '104104271480491', //VERSO hua hin - a Veranda Collection
  '346030320266', // Studio7
  '105400738920268', //Test Gaming Nation
  '108234815144840', //Nestle
  '110981841237323', //Nestle
  '1037700739663223', //Nestle
  '101542172593323', //Nestle
  '100305558382056', //TEST Live
  '102370245472711', //TEST LAMY
  '113333408388614', //Test Laz 2
  '1737574596477450', // giraffio
  '188869521221562', // lazada
  '462339517184685', // test city fresh fruit
  '105432182130709', // city fresh fruit
  '101536496332228', //Test kratingdaeng
  '110406068769385', // Test Sponsor
  '104152609400717', // Test Somplus
  '101236219696124', //Test Ready
  '116908048108889', //Test Mansome
  '117855651346123', //Test Puriku
  '112625705212742', //Test Sunsnack
  '113384421800781', //Test hixdhc
  '115567481582677', //planet
  '109272465563413', //Farmza
  '111301538678718', //Test TCPShop Master
  '106378945313542', //TCPShop Master
  '165390986804835', //kratingdaeng
  '106699346035522', //	Sponsor
  '649066842180929', //	Somplus
  '118926511456194', //	Ready
  '399345200114928', //	Mansome
  '144080440883', //	Puriku
  '114646638621839', //	Sunsnack
  '106668880896781', //	hixdhc
  '106818062395292', //	planet
  '107107852331881' //	Farmza
]



// WEBPACK FOOTER //
// ./src/constants/ntn.js